export enum ApiServicesAgreementWorkflowTransitionKind {
	Create = 'Create',
	Send = 'Send',
	Negotiate = 'Negotiate',
	FinallySign = 'FinallySign',
	Start = 'Start',
	Finish = 'Finish',
	Cancel = 'Cancel',
	Reject = 'Reject',
	Expired = 'Expired',
	Update = 'Update',
	ReturnToSent = 'ReturnToSent',
	ReturnToNegotiated = 'ReturnToNegotiated',
}
